import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Container } from 'react-bootstrap';
import {Post} from '../types/post';
import postsData from '../data/posts.json';
import { Link } from 'react-router-dom';
import { bloggerPostList } from '../types/bloggerServices';
import { getPosts } from '../services/blogger';



const PostList: React.FC = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const issue_cover='https://fatteh-media-files.s3.amazonaws.com/pages/magazine/cover1.webp'
  const [posts, setPosts] = useState<bloggerPostList[]>();
  

  // Convert JSON data to Post array
  //const posts: Post[] = postsData as Post[];

  // Format date to Ethiopian format (YYYY-MM-DD to MM/DD/YYYY)
  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US');
  };

  const getData = async () => {
    try{
      const response = await getPosts();
      console.log(response.items);
      setPosts(response.items)
    }
    catch(e){
      console.log(e);
    }
  }

  useEffect(() => {
    getData()
  }, []);

  return (
    <Container className="post-list-container route-container">
      <Row>
          <Col xs={12} sm={6}>
            <div className='issue-cover'>
              <img src={issue_cover} />
            </div>
          </Col>
          <Col xs={12}sm={6}>
            <Row>
              <h2 className="section-title">Recent Articles</h2>
              {posts ? posts.slice(0,4).map((post, index) => (
                <Col key={index} sm={12} md={12}lg={6} className="mb-4" as={Link} to={`${post.id}`} style={{textDecoration: "none"}}>
                  <Card className="h-100 post-card">
                    <div className="post-image" style={{backgroundImage: `url(${post.images[0].url})`}}></div>
                    <Card.Body>
                      <Card.Title className="post-title">{post.title}</Card.Title>
                      <div className="post-meta">
                        <span className="post-author">By {post.author.displayName}</span>
                        <span className="post-date">{formatDate(post.published)}</span>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))
            :
            <h1>Could not find posts</h1>}
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default PostList;